import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../components/ui/CustomModal';
import { formatNumber, parseFormattedNumber } from '../../utils/helpers';

export const AccountModal = ({ isOpen, onClose, onSave, existingAccount }) => {
    const [account, setAccount] = useState({ name: '', type: 'Ngân hàng', balance: 0 });

    useEffect(() => {
        if (existingAccount) {
            setAccount(existingAccount);
        } else {
            setAccount({ name: '', type: 'Ngân hàng', balance: 0 });
        }
    }, [existingAccount, isOpen]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAccount(p => ({...p, [name]: value}));
    };

    const handleBalanceChange = (e) => {
        const { value } = e.target;
        setAccount(p => ({ ...p, balance: parseFormattedNumber(value) }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(account, !!existingAccount);
    };

    return (
        <CustomModal isOpen={isOpen} onClose={onClose} title={existingAccount ? "Sửa tài khoản" : "Tạo Tài Khoản Mới"}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="accountName" className="text-sm font-medium text-gray-700">Tên tài khoản</label>
                    <input id="accountName" type="text" name="name" placeholder="Ví dụ: Vietcombank, Quỹ tiền mặt" value={account.name} onChange={handleInputChange} className="mt-1 w-full p-3 border rounded-md" required />
                </div>
                <div>
                    <label htmlFor="accountType" className="text-sm font-medium text-gray-700">Loại tài khoản</label>
                    <select id="accountType" name="type" value={account.type} onChange={handleInputChange} className="mt-1 w-full p-3 border rounded-md bg-white">
                        <option>Ngân hàng</option>
                        <option>Tiền mặt</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="initialBalance" className="text-sm font-medium text-gray-700">Số dư ban đầu</label>
                    <input id="initialBalance" type="text" name="balance" placeholder="Nhập số dư ban đầu" value={formatNumber(account.balance)} onChange={handleBalanceChange} className={`mt-1 w-full p-3 border rounded-md ${!!existingAccount ? 'bg-gray-100' : ''}`} disabled={!!existingAccount} />
                    {existingAccount && <p className="text-xs text-gray-500 mt-1">Không thể sửa số dư trực tiếp. Vui lòng tạo phiếu thu/chi để điều chỉnh.</p>}
                </div>
                <div className="flex justify-end gap-3 pt-4 border-t">
                    <button type="button" onClick={onClose} className="py-2 px-5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Hủy</button>
                    <button type="submit" className="py-2 px-5 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Lưu</button>
                </div>
            </form>
        </CustomModal>
    );
};